import { InfoOutlined } from "@mui/icons-material";
import { IconButton, IconButtonProps, Popover, PopoverProps } from "@mui/material";
import { ReactNode, useState } from "react";

export default function InfoPopup({
    children,
    buttonProps,
    popoverProps,
}: {
    children?: ReactNode;
    buttonProps?: Partial<IconButtonProps>;
    popoverProps?: Partial<PopoverProps>;
}) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    return (
        <>
            <IconButton
                {...buttonProps}
                aria-haspopup="true"
                onClick={(e) => {
                    e.stopPropagation();
                    setAnchorEl(e.currentTarget);
                }}
            >
                <InfoOutlined />
            </IconButton>
            <Popover
                {...popoverProps}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onClose={(e) => {
                    (e as MouseEvent)?.stopPropagation();
                    setAnchorEl(null);
                }}
            >
                {children}
            </Popover>
        </>
    );
}
